import { createRouter, createWebHistory } from 'vue-router'
import { authGuard } from './authGuard'

// Import views
const LoginPage = () => import('../views/LoginPage.vue')
const BookingsPage = () => import('../views/BookingsPage.vue')
const BookingDetailsPage = () => import('../views/BookingDetailsPage.vue')
const TaskDetailsPage = () => import('../views/TaskDetailsPage.vue')
const ReviewsPage = () => import('../views/ReviewsPage.vue')
const QuotePage = () => import('../views/QuotePage.vue')
const ProfilePage = () => import('../views/ProfilePage.vue')
const TimesheetPage = () => import('../views/TimesheetPage.vue')
const InspectionsListPage = () => import('../views/InspectionsListPage.vue')
const InspectionWizardPage = () => import('../views/InspectionWizardPage.vue')
const CommercialReportsListPage = () => import('../views/CommercialReportsListPage.vue')
const CommercialReportWizardPage = () => import('../views/CommercialReportWizardPage.vue')
const CallbackPage = () => import('../views/CallbackPage.vue')
const AccessDeniedPage = () => import('../views/AccessDeniedPage.vue')

const routes = [
  {
    path: '/',
    redirect: '/bookings'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: '/callback',
    name: 'Callback',
    component: CallbackPage,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: '/access-denied',
    name: 'AccessDenied',
    component: AccessDeniedPage,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: '/bookings',
    name: 'Bookings',
    component: BookingsPage,
    beforeEnter: authGuard
  },
  {
    path: '/bookings/:id',
    name: 'BookingDetails',
    component: BookingDetailsPage,
    props: true,
    beforeEnter: authGuard
  },
  {
    path: '/tasks/:id',
    name: 'TaskDetails',
    component: TaskDetailsPage,
    props: true,
    beforeEnter: authGuard
  },
  {
    path: '/reviews',
    name: 'Reviews',
    component: ReviewsPage,
    beforeEnter: authGuard
  },
  {
    path: '/quote',
    name: 'Quote',
    component: QuotePage,
    beforeEnter: authGuard
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage,
    beforeEnter: authGuard
  },
  {
    path: '/timesheet',
    name: 'Timesheet',
    component: TimesheetPage,
    beforeEnter: authGuard
  },
  {
    path: '/inspections',
    name: 'Inspections',
    component: InspectionsListPage,
    beforeEnter: authGuard
  },
  {
    path: '/inspections/new',
    name: 'NewInspection',
    component: InspectionWizardPage,
    beforeEnter: authGuard
  },
  {
    path: '/inspections/:inspectionId',
    name: 'InspectionWizard',
    component: InspectionWizardPage,
    props: true,
    beforeEnter: authGuard
  },
  {
    path: '/commercial-reports',
    name: 'CommercialReports',
    component: CommercialReportsListPage,
    beforeEnter: authGuard
  },
  {
    path: '/commercial-reports/new',
    name: 'NewCommercialReport',
    component: CommercialReportWizardPage,
    beforeEnter: authGuard
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router